import React, { Fragment } from 'react'

import Churning from './Churning'
import Grace from './Grace'
import Renewing from './Renewing'
import Unlimited from './Unlimited'
import { useActiveMembershipContext } from '../ActiveMembershipStore'

const renderSubscriptionComponents = (state) => {
  switch (state) {
    case 'churning': {
      return <Churning />
    }
    case 'grace':
    case 'unknown': {
      return <Grace />
    }
    case 'renewing': {
      return <Renewing />
    }
    case 'unlimited': {
      return <Unlimited />
    }
    default:
      return null
  }
}

const SubscriptionStates = () => {
  const { membershipInfo } = useActiveMembershipContext()
  return (
    <Fragment>
      {membershipInfo &&
        renderSubscriptionComponents(membershipInfo.subscriptionState)}
    </Fragment>
  )
}

export default SubscriptionStates
